/** Same brand string as the web app's `metadata.title.default`. */
export const FUNNEL_BRAND = 'OrganicFit';
/** Same separator as the web app's title template (`%s — OrganicFit`). */
const SEPARATOR = ' — ';

/**
 * One section per funnel route. The quiz keeps the bare brand on purpose: a per-question title floods the
 * browser history and lands in every autocaptured analytics event.
 *
 * Text comes from the locale files (`meta.title.<id>`, `meta.brand`) so growth can change or localise it
 * without a deploy; the fallbacks below are what ships.
 */
interface TitleSection {
  id: string;
  paths: string[];
  fallback: string;
}

const SECTIONS: TitleSection[] = [
  { id: 'paywall', paths: ['/paywall', '/d-offer'], fallback: 'Your plan' },
  { id: 'success', paths: ['/success'], fallback: 'Payment confirmed' },
  { id: 'register', paths: ['/register'], fallback: 'Create account' },
  { id: 'upsells', paths: ['/upsells'], fallback: 'Special offer' },
  { id: 'download', paths: ['/download'], fallback: 'Get the app' },
];

export type TitleTranslate = (keys: string[]) => string | undefined;

const normalize = (pathname: string): string => `/${pathname.replace(/^\/+|\/+$/g, '')}`;

export const sectionForPath = (pathname: string): TitleSection | undefined =>
  SECTIONS.find((section) => section.paths.includes(normalize(pathname)));

/** `<section> — <brand>`, or the bare brand on the quiz and on any unmapped route. */
export const documentTitleFor = (pathname: string, translate?: TitleTranslate): string => {
  const brand = translate?.(['meta.brand'])?.trim() || FUNNEL_BRAND;
  const section = sectionForPath(pathname);
  if (!section) return brand;
  const label = translate?.([`meta.title.${section.id}`])?.trim() || section.fallback;
  return label ? `${label}${SEPARATOR}${brand}` : brand;
};
